import { render } from "./CustomersPage.vue?vue&type=template&id=ac7dac1e&ts=true"
import script from "./CustomersPage.ts?vue&type=script&lang=ts"
export * from "./CustomersPage.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__